import { useState, useEffect, useCallback, useRef } from 'react';

// --- Cache Structure ---
export interface CacheEntry<T> {
  data: T;
  timestamp: number; // When the data was fetched/stored
}

// Global cache stored in memory (outside the hook)
// Use Map for efficient key lookups
export const cache = new Map<string, CacheEntry<any>>();

// --- Hook Options ---
export interface UseCacheOptions<T> {
  ttl?: number; // Time-to-live in milliseconds
  initialData?: T; // Optional initial data
  // Add other options like onSuccess, onError later if needed
}

// --- Hook Return Value ---
export interface UseCacheReturn<T> {
  data: T | undefined; // The cached or fetched data
  error: Error | null;   // Any error during fetch
  isLoading: boolean;   // True during initial fetch (no data yet)
  isValidating: boolean; // True during any fetch (initial or revalidation)
  mutate: (newData?: T | Promise<T>) => Promise<T | undefined>; // Function to trigger refetch or update cache
}

// --- Default TTL (e.g., 5 minutes) ---
export const DEFAULT_TTL = 5 * 60 * 1000;
